import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import "./AvatarEditor.css";
import AvatarPreview from "./AvatarPreview";
import AvatarCategoryTabs from "./AvatarCategoryTabs";
import AvatarOptions from "./AvatarOptions";
import {
  avatarCategories,
  avatarOptions,
  defaultAvatar,
  getAvatarAsset,
} from "./avatarConfig";

const MOBILE_QUERY = "(max-width: 900px)";

const AvatarEditor = ({ initialAvatar = defaultAvatar, onBack, onSave }) => {
  const [activeCategory, setActiveCategory] = useState("face");
  const [avatar, setAvatar] = useState(() => ({
    ...defaultAvatar,
    ...initialAvatar,
  }));
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" &&
    window.matchMedia(MOBILE_QUERY).matches
  );
  const scrollRef = useRef(null);

  useEffect(() => {
    const query = window.matchMedia(MOBILE_QUERY);
    const handleResize = () => setIsMobile(query.matches);
    handleResize();
    query.addEventListener("change", handleResize);
    return () => query.removeEventListener("change", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
    return () => { document.body.style.overflow = previousOverflow; };
  }, [isMobile]);

  const selectedBackground = getAvatarAsset("background", avatar.background);

  const handleSelectOption = (optionId) => {
    setAvatar((currentAvatar) => ({
      ...currentAvatar,
      [activeCategory]: optionId,
    }));
  };

  const editorContent = (
    <div
      ref={scrollRef}
      className={`avatar-editor-scroll-wrapper${isMobile ? " avatar-editor-mobile" : ""}`}
    >
      <div className="avatar-editor-page">
        <div className="avatar-editor-header">
          <button
            type="button"
            className="avatar-back-button"
            onClick={onBack}
            aria-label="Inapoi la profil"
          >
            ←
          </button>
          <h1>Editeaza avatarul</h1>
        </div>

        <div className="avatar-editor-container">
          <div
            className="avatar-editor-preview-section"
            style={{ backgroundColor: selectedBackground?.color || "#d6f2fe" }}
          >
            <AvatarPreview avatar={avatar} />
          </div>
          <div className="avatar-editor-customization">
            <AvatarCategoryTabs
              categories={avatarCategories}
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory}
            />
            <AvatarOptions
              options={avatarOptions[activeCategory] || []}
              selectedOption={avatar[activeCategory]}
              onSelect={handleSelectOption}
            />
          </div>
        </div>

        <div className="avatar-editor-actions">
          <button
            type="button"
            className="avatar-save-button"
            onClick={() => onSave?.(avatar)}
          >
            SALVEAZA AVATARUL
          </button>
        </div>
      </div>
    </div>
  );

  return isMobile ? createPortal(editorContent, document.body) : editorContent;
};

export default AvatarEditor;
